import aboutYouWhite from './about-you-white.svg'
import aboutYouPrimary from './about-you-primary.svg'
import aboutYouDemo from './about-you-demo.svg'
import healthWhite from './health-white.svg'
import healthPrimary from './health-primary.svg'
import healthDemo from './health-demo.svg'

const data = [
  {
    title: 'About you',
    subtitle:
      'First up, we have a few simple questions to help us get to know you better. Your answers will help us recommend the right health checks for you.',
    completion: 'Total completion time 2-3 minutes',
    groupId: 'demographic',
    imageSection: aboutYouWhite,
    imageQuestion: aboutYouPrimary,
    imageQuestionDemo: aboutYouDemo,
    buttonLabel: 'Start',
    questions: [
      {
        title: 'What is your sex?',
        apiName: 'sex',
        info: 'Some health checks are based on gender, more specifically your sexual organs. Even if you identify as another gender, your health recommendations may differ depending on your sex.',
        type: 'one',
        answers: [
          {
            title: 'Male',
            value: 'male'
          },
          {
            title: 'Female',
            value: 'female'
          },
          {
            title: 'Other',
            value: 'other'
          }
        ]
      },
      {
        title: 'What gender do you identify as?',
        apiName: 'gender',
        type: 'one',
        answers: [
          {
            title: 'Male',
            value: 'male'
          },
          {
            title: 'Female',
            value: 'female'
          },
          {
            title: 'Other',
            value: 'other'
          },
          {
            title: 'Prefer not to say',
            value: 'prefer not to say'
          }
        ]
      },
      {
        title: 'What is your date at birth?',
        info: 'Most health checks are based on age. Your date of birth will help determine the health checks most relevant for you along with the recommended frequency of these checks.',
        apiName: 'dob',
        type: 'date',
        answers: [
          {
            rangeYears: '18-100'
          }
        ]
      },
      {
        title: 'What state or territory do you live in?',
        apiName: 'state',
        type: 'select',
        answers: [
          {
            title: 'Australian Capital Territory',
            value: 'Australian Capital Territory'
          },
          {
            title: 'New South Wales',
            value: 'New South Wales'
          },
          {
            title: 'Northern Territory',
            value: 'Northern Territory'
          },
          {
            title: 'Queensland',
            value: 'Queensland'
          },
          {
            title: 'South Australia',
            value: 'South Australia'
          },
          {
            title: 'Tasmania',
            value: 'Tasmania'
          },
          {
            title: 'Victoria',
            value: 'Victoria'
          },
          {
            title: 'Western Australia',
            value: 'Western Australia'
          }
        ]
      },
      {
        title: 'What is your occupation?',
        apiName: 'occupation',
        type: 'select',
        answers: [
          {
            title: 'Manager',
            value: 'Manager'
          },
          {
            title: 'Professional',
            value: 'Professional'
          },
          {
            title: 'Technician and/or trades worker',
            value: 'Technician and/or trades worker'
          },
          {
            title: 'Community and/or personal worker',
            value: 'Community and/or personal worker'
          },
          {
            title: 'Clerical and/or administrative worker',
            value: 'Clerical and/or administrative worker'
          },
          {
            title: 'Sales worker',
            value: 'Sales worker'
          },
          {
            title: 'Machinery operator and/or driver',
            value: 'Machinery operator and/or driver'
          },
          {
            title: 'Labourer',
            value: 'Labourer'
          },
          {
            title: 'Other',
            value: 'Other'
          }
        ]
      },
      {
        title: 'Are you of Aboriginal and/or Torres Strait Islander descent?',
        apiName: 'atsi',
        info: 'If you are of Aboriginal and/or Torres Strait Islander descent, you may be recommended to have certain health checks at a different age compared to non-Indigenous Australians.',
        type: 'one',
        answers: [
          {
            title: 'Yes',
            value: 'yes'
          },
          {
            title: 'No',
            value: 'no'
          },
          {
            title: "I'd prefer not to say",
            value: 'prefer not to say'
          }
        ]
      }
    ]
  },
  {
    title: 'Your health history',
    subtitle:
      "The next few questions will help us understand a bit more about your health history. If you're not sure about the answer, that's OK.",
    // readMore: true,
    groupId: 'health',
    imageSection: healthWhite,
    imageQuestion: healthPrimary,
    imageQuestionDemo: healthDemo,
    buttonLabel: 'Continue',
    questions: [
      {
        title: 'What is your height and weight?',
        apiName: 'heightWeight',
        type: 'additions',
        answers: [
          {
            title: 'Height',
            value: 'height',
            addition: 'cm'
          },
          {
            title: 'Weight',
            value: 'weight',
            addition: 'kg'
          }
        ]
      },
      {
        title: 'Bowel cancer or polyps',
        info: 'Bowel cancer (also known as colorectal cancer) is a cancer that forms in the large intestine and/or rectum. A polyp is a growth that can occur in the bowel but is usually benign (non-threatening).',
        apiName: 'bowelCancerOrPolyps',
        type: 'one',
        answers: [
          {
            title: 'Both a personal and a family history',
            value: 'personal and family'
          },
          {
            title: 'Personal history only',
            value: 'personal'
          },
          {
            title: 'Family history only',
            value: 'family'
          },
          {
            title: 'Neither a personal or a family history',
            value: 'none'
          },
          {
            title: 'I am unsure',
            value: 'unsure'
          }
        ]
      },
      {
        title: 'Breast cancer',
        info: 'Breast cancer is a type of cancer that forms in cells lining the lobules or ducts of the breast.',
        apiName: 'breastCancer',
        condition: 'female',
        type: 'one',
        answers: [
          {
            title: 'Both a personal and a family history',
            value: 'personal and family'
          },
          {
            title: 'Personal history only',
            value: 'personal'
          },
          {
            title: 'Family history only',
            value: 'family'
          },
          {
            title: 'Neither a personal or a family history',
            value: 'none'
          },
          {
            title: 'I am unsure',
            value: 'unsure'
          }
        ]
      },
      {
        title: 'Skin cancer',
        info: 'Skin cancer (also referred to as melanoma, basal cell carcinoma and squamous cell carcinoma) is a cancer that forms when skin cells are damaged- often by overexposure to ultraviolet (UV) radiation from the sun.',
        apiName: 'skinCancer',
        type: 'one',
        answers: [
          {
            title: 'Both a personal and a family history',
            value: 'personal and family'
          },
          {
            title: 'Personal history only',
            value: 'personal'
          },
          {
            title: 'Family history only',
            value: 'family'
          },
          {
            title: 'Neither a personal or a family history',
            value: 'none'
          },
          {
            title: 'I am unsure',
            value: 'unsure'
          }
        ]
      },
      {
        title: 'Cardiovascular disease',
        info: 'Cardiovascular disease is a term used to describe diseases of the heart and blood vessels. This can include a heart attack, angina, stroke, peripheral vascular disease and heart failure.',
        apiName: 'heartDisease',
        type: 'one',
        answers: [
          {
            title: 'Both a personal and a family history',
            value: 'personal and family'
          },
          {
            title: 'Personal history only',
            value: 'personal'
          },
          {
            title: 'Family history only',
            value: 'family'
          },
          {
            title: 'Neither a personal or a family history',
            value: 'none'
          },
          {
            title: 'I am unsure',
            value: 'unsure'
          }
        ]
      },
      {
        title: 'Diabetes',
        info: 'Type 2 diabetes is a condition where your body isn’t able to process glucose (a type of sugar) properly after you eat or drink. This is because of the lack of insulin (a hormone) or the body’s resistance to the effects of insulin.',
        apiName: 'diabetes',
        type: 'one',
        answers: [
          {
            title: 'Both a personal and a family history',
            value: 'personal and family'
          },
          {
            title: 'Personal history only',
            value: 'personal'
          },
          {
            title: 'Family history only',
            value: 'family'
          },
          {
            title: 'Neither a personal or a family history',
            value: 'none'
          },
          {
            title: 'I am unsure',
            value: 'unsure'
          }
        ]
      },
      {
        title: 'When was the last time you visited a doctor?',
        apiName: 'lastVisitToDoctor',
        type: 'one',
        answers: [
          {
            title: 'Within the last 12 months',
            value: 'less than 12 months'
          },
          {
            title: '12-24 months ago',
            value: '12 to 24 months'
          },
          {
            title: 'More than 24 months ago',
            value: 'more than 24 months'
          }
        ]
      },
      {
        title: 'When was the last time you had a bowel cancer screening?',
        apiName: 'bowelCancerHomeScreen',
        info: 'A bowel cancer screening can include using a bowel cancer screening kit (also known as a Faecal Occult Blood Test, or FOBT) or having had a colonoscopy.',
        type: 'one',
        answers: [
          {
            title: 'Within the last 12 months',
            value: 'less than 12 months'
          },
          {
            title: '12-24 months',
            value: '12 to 24 months'
          },
          {
            title: 'More than 24 months ago',
            value: 'more than 24 months'
          },
          {
            title: 'Never',
            value: 'never'
          }
        ]
      },
      {
        title: 'When was the last time you had a breast cancer screening?',
        apiName: 'breastCancerScreen',
        info: 'A breast cancer screening can include having a mammogram (a low-energy x-ray to the breast), an ultrasound, tomosythesis or an MRI scan.',
        condition: 'female',
        type: 'one',
        answers: [
          {
            title: 'Within the last 12 months',
            value: 'less than 12 months'
          },
          {
            title: '12-24 months',
            value: '12 to 24 months'
          },
          {
            title: 'More than 24 months ago',
            value: 'more than 24 months'
          },
          {
            title: 'Never',
            value: 'never'
          }
        ]
      },
      {
        title: 'When was the last time you had a heart health check?',
        apiName: 'heartHealthCheck',
        info: 'A heart health check is a check-up performed by your doctor. It involves looking at various risk factors such as your cholesterol levels and blood pressure and talking about your lifestyle such as how much physical activity you are doing, what you’re eating and whether you smoke.',
        type: 'one',
        answers: [
          {
            title: 'Within the last 12 months',
            value: 'less than 12 months'
          },
          {
            title: '12-24 months',
            value: '12 to 24 months'
          },
          {
            title: 'More than 24 months ago',
            value: 'more than 24 months'
          },
          {
            title: 'Never',
            value: 'never'
          }
        ]
      },
      {
        title: 'When was the last time you had a skin cancer check?',
        apiName: 'skinCheckByGP',
        info: 'A skin cancer check can be performed by your doctor or a dermatologist. It involves looking at the skin for any suspicious spots or lesions and talking about your skin type and other risk factors.',
        type: 'one',
        answers: [
          {
            title: 'Within the last 12 months',
            value: 'less than 12 months'
          },
          {
            title: '12-24 months',
            value: '12 to 24 months'
          },
          {
            title: 'More than 24 months ago',
            value: 'more than 24 months'
          },
          {
            title: 'Never',
            value: 'never'
          }
        ]
      },
      {
        title: 'Do you currently smoke cigarettes or other tobacco products?',
        apiName: 'smokingStatus',
        type: 'one',
        answers: [
          {
            title: 'Yes',
            value: 'yes'
          },
          {
            title: 'No',
            value: 'no'
          },
          {
            title: 'I quit in the last 12 months',
            value: 'quit within last 12 months'
          }
        ]
      },
      {
        title:
          'Are you currently on medication for blood pressure and/or cholesterol?',
        apiName: 'heartHealthMedication',
        type: 'one',
        answers: [
          {
            title: 'Yes, both blood pressure and cholesterol medication',
            value: 'blood pressure and cholesterol'
          },
          {
            title: 'Yes, blood pressure medication only',
            value: 'blood pressure'
          },
          {
            title: 'Yes, cholesterol medication only',
            value: 'cholesterol'
          },
          {
            title: 'No',
            value: 'no'
          }
        ]
      }
    ]
  }
]

export default data
